export default "__VITE_ASSET__f48e6c38__"